export default "__VITE_ASSET__CxbGTAtl__"